import { annotationsApi } from './domains/annotations';
import { armsApi } from './domains/arms';
import { boxApi } from './domains/box';
import { builderApi } from './domains/builder';
import { contactApi } from './domains/contact';
import { documentsApi } from './domains/documents';
import { dropdownsApi } from './domains/dropdowns';
import { emailApi } from './domains/email';
import { nextPatientApi, nextPatientCarePathwayApi } from './domains/nextPatient';
import { nextPatientTrackingApi } from './domains/nextPatientTracking';
import { nextPrescreeningApi } from './domains/nextPrescreening';
import { patientCohortMatchApi } from './domains/patientCohortMatch';
import { patientTrackerApi, timePatientApi } from './domains/patientTracker';
import { patientsLegacyApi } from './domains/patientsLegacy';
import { patientsNewApi } from './domains/patientsNew';
import { programSitesApi } from './domains/programSites';
import { providerDashboardsApi } from './domains/providerDashboards';
import { searchesApi } from './domains/searches';
import { nextSearchApi } from './domains/nextSearch';
import { tasksApi } from './domains/tasks';
import { timeScreeningApi } from './domains/timeScreening';
import { timeSitesApi } from './domains/timeSites';
import { trialMatchesApi, trialSitesSearchApi, trialsApi } from './domains/trials';
import { usersApi } from './domains/users';
import { programManagementApi } from './domains/programManagement';
import { siteTrialsPatientsApi } from './domains/siteTrialsPatients';

export { TRIALS_API_ROOT, TRIALS_NEST_API_ROOT, getSelectedSiteId } from './constants';

const Api = {
  annotations: annotationsApi,
  arms: armsApi,
  contact: contactApi,
  programSites: programSitesApi,
  searches: searchesApi,
  timeSites: timeSitesApi,
  trials: trialsApi,
  documents: documentsApi,
  dropdowns: dropdownsApi,
  email: emailApi,
  patients: patientsLegacyApi,
  trialMatches: trialMatchesApi,
  trialSitesSearch: trialSitesSearchApi,
  users: usersApi,
  box: boxApi,
  patientTrackerV2: patientTrackerApi,
  timePatient: timePatientApi,
  timeScreening: timeScreeningApi,
  nextPatient: nextPatientApi,
  nextPatientCarePathway: nextPatientCarePathwayApi,
  nextPrescreening: nextPrescreeningApi,
  builder: builderApi,
  patientsNew: patientsNewApi,
  patientCohortMatch: patientCohortMatchApi,
  providerDashboards: providerDashboardsApi,
  nextPatientTracking: nextPatientTrackingApi,
  nextSearch: nextSearchApi,
  tasks: tasksApi,
  programManagement: programManagementApi,
  siteTrialsPatients: siteTrialsPatientsApi,
};

export default Api;
